import { ReactNode, createContext, useContext } from "react";
import { useFilterLevel } from "./filter-level.hook";

const FilterLevelContext = createContext(
  {} as ReturnType<typeof useFilterLevel>
);
export function useFilterLevelContext() {
  return useContext(FilterLevelContext);
}

interface FilterLevelProviderProps {
  children: ReactNode;
}
export function FilterLevelProvider({
  children,
}: FilterLevelProviderProps) {
  return (
    <FilterLevelContext.Provider value={useFilterLevel()}>
      {children}
    </FilterLevelContext.Provider>
  );
}